
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/blogs/[itemID]",
      function () {
        return require("private-next-pages/brand/blogs/[itemID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/blogs/[itemID]"])
      });
    }
  